import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-6" }

import { 	// api
		getAttendeeByRecordId
	} from '../queries'
	
	import EventBus from '@/events' // components
	import DocumentDetails from './DocumentDetails.vue'
	import TransportationDetails from './TransportationDetails.vue'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // types
		FileMakerRecord
	} from '@/types'

	import { // vue
		inject,
		onMounted, 
		onBeforeUnmount,
		ref,
		computed
	} from 'vue'

	
	const __default__ = { name: 'AttendeesDetailsModal' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		attendee: {
			type: Object,
			default: () => {return {}}
		},
		openToTab: {
			type: Number,
			default: 0
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const userStore = _userStore()

	const tabs = computed(() => {
		if (userStore.getContactType == 'Staff') {
			return [
				{ name: _localesStore.getLabel('185'), current: false }, // Transportation
				{ name: _localesStore.getLabel('203'), current: false }  // Documents
			]
		}
		else {
			return [
				{ name: _localesStore.getLabel('203'), current: false }  // Documents
			]
		}
	})

	const childTabs = ref<{_tabs: []}>({_tabs: []})
	const loading = ref(false)

	const attendeeRecord = ref<FileMakerRecord>({} as FileMakerRecord)

	onMounted(async () => {
		tabs.value[props.openToTab].current = true

		await getData()

		EventBus.on('change-language', async () => {
			await getData(true)
		})
	})

	onBeforeUnmount(() => {
		EventBus.off('change-language', null)
	})

	async function getData(reset: boolean = false) {
		try { // fetching job by record id
			loading.value = true
					
			const res = await getAttendeeByRecordId(props.attendee.recordId)
			const record = res.response.data[0]
			attendeeRecord.value = record

			fetchTaxDocuments() 
			fetchAttendeeDocuments()
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}

	const loadingAttendeeDocuments = ref(true)
	const loadingTaxDocuments = ref(true)
	const s3: any = inject('s3')

	async function fetchTaxDocuments() {
		try { // fetching tax document files from s3
			loadingTaxDocuments.value = true
			attendeeRecord.value?.portalData?.['attendees__DOCUMENTS__attendeesTaxesID'].forEach((document: any) => {
				const documentS3Json = JSON.parse(document?.['attendees__DOCUMENTS__attendeesTaxesID::s3JSONDocument'] || "{}")
				const documentKey = documentS3Json?.s3FilePathShortRaw
				const ext = documentS3Json?.fileExt
				document.ext = ext

				if(documentKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: documentKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							document.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loadingTaxDocuments.value = false
		}
	}

	async function fetchAttendeeDocuments() {
		try { // fetching role document files from s3
			loadingAttendeeDocuments.value = true
			attendeeRecord.value?.portalData?.['attendees__DOCUMENTS__attendeesID'].forEach((document: any) => {
				const documentS3Json = JSON.parse(document?.["attendees__DOCUMENTS__attendeesID::s3JSONDocument"] || "{}")
				const documentKey = documentS3Json?.s3FilePathShortRaw

				if(documentKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: documentKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							document.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loadingAttendeeDocuments.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_tabs_underline = _resolveComponent("tw-tabs-underline")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_tw_tabs_underline, {
      ref_key: "childTabs",
      ref: childTabs,
      tabs: tabs.value
    }, null, 8, ["tabs"]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TransportationDetails, {
          loading: loading.value,
          attendee: attendeeRecord.value
        }, null, 8, ["loading", "attendee"])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[0]?.current && _unref(userStore).getContactType == 'Staff']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DocumentDetails, {
          loading: loading.value,
          attendee: attendeeRecord.value
        }, null, 8, ["loading", "attendee"])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[_unref(userStore).getContactType == 'Client' ? 0 : 1]?.current]
    ])
  ]))
}
}

})